export default __webpack_public_path__ + "static/media/okt-main-slider-1.48bd5fd7.png";